import { render, staticRenderFns } from "./FeeTable.vue?vue&type=template&id=d6cfc52e&"
import script from "./FeeTable.vue?vue&type=script&lang=js&"
export * from "./FeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports